module.exports = __webpack_public_path__ + "img/cloud3_2.11396033.png";